module.exports = __webpack_public_path__ + "img/GPB_Top10_2019-2.84b0a786.png";